import { render, staticRenderFns } from "./head_page.vue?vue&type=template&id=2aa2c012&scoped=true&"
import script from "./head_page.vue?vue&type=script&lang=js&"
export * from "./head_page.vue?vue&type=script&lang=js&"
import style0 from "./head_page.vue?vue&type=style&index=0&id=2aa2c012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa2c012",
  null
  
)

export default component.exports